import { documentIntakeReducer } from './documentIntake.reducer';

export default { documentIntake: documentIntakeReducer };
